import { __assign } from "tslib";
import React from 'react';
import { SDKAdapterConsumer } from '../../contexts/SDKAdapterContext';
import { BaseSettingsTabLayout } from './BaseSettingsTabLayout';
import { Tab, UpgradeButtonTab, DividerTab, ButtonTab } from './tabs';
import { BIConsumer } from '../../contexts/BIContext';
export var SettingsTabLayout = function (props) {
    return (React.createElement(SDKAdapterConsumer, null, function (_a) {
        var SDKAdapter = _a.SDKAdapter;
        return (React.createElement(BIConsumer, null, function (bi) { return (React.createElement(BaseSettingsTabLayout, __assign({}, props, { SDKAdapter: SDKAdapter, bi: bi }))); }));
    }));
};
SettingsTabLayout.Tab = Tab;
SettingsTabLayout.UpgradeButton = UpgradeButtonTab;
SettingsTabLayout.Divider = DividerTab;
SettingsTabLayout.Button = ButtonTab;
//# sourceMappingURL=SettingsTabLayout.js.map